// extracted by mini-css-extract-plugin
export default {"description":"CreateStudents_description__8Uyxh","numberInput":"CreateStudents_numberInput__pTWT9","fadeIn":"CreateStudents_fadeIn__jNoUk","fadeOut":"CreateStudents_fadeOut__QjX7+"};